import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';

@Injectable()
export class ChangePasswordDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) { }

  /**
   * Cambio de contraseña de usuario
   *
   * @param {string} currentPassword
   * @param {string} newPassword
   * @returns {Observable<boolean>}
   * @memberof ChangePasswordDataService
   */
  changePassword(currentPassword: string, newPassword: string): Observable<boolean> {
    return new Observable(obs => {
      const dataForm = {
        password: currentPassword,
        new_password: newPassword
      };
      this.http.skipErrorHandler().post(this.api.get('changeUserPassword'), dataForm).subscribe(
        res => {
          if (res['message']) {
            this.toastr.success(res['message'], 'Operación exitosa');
          } else {
            this.toastr.success('Contraseña actualizada correctamente', 'Operación exitosa');
          }
          obs.next(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            if (err.error.message) {
              this.toastr.error(err.error.message, 'Error de operación');
            } else if (typeof err.error === 'string') {
              this.toastr.error(err.error, 'Error de operación');
            } else {
              this.toastr.error('Lo sentimos ha ocurrido un error', 'Error de operación');
            }
          }
          obs.error(err);
        }
      );
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/change-password/shared/change-password.data.service.ts